import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import Base, { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/ewc/altermgr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/ewc/altermgr`,
};

export const URLS = {
    ewci1001007q: `${BASE.path}/ewci1001007q`, // Alert Receiver Management List !== 경보 수신자 관리 목록 ==!
    ewci1001008s: `${BASE.path}/ewci1001008s`, // Alert Receiver Management Details !== 경보 수신자 관리 상세 ==!
    ewci1001009s: `${BASE.path}/ewci1001009s`, // Alert Receiver Management Edit !== 경보 수신자 관리 수정 ==!
};

export const APIS = {
    // Get Alert Receiver Management List. !== EWACS 경고 목록 조회.==!
    getAlterMgrList: (data: any) => {
        return api.get(`${BASE.api}/alert-rules`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Alert Receiver Management List. !== EWACS 경고 목록 조회.==!
    getAlterMgrDtl: (data: any) => {
        return api.get(`${BASE.api}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getAlrtRecptMgmtList: (alrtId: any) => {
        console.log(alrtId);
        return api.get(`${BASE.api}/alert-recpt/${alrtId}`);
    },
    saveAlterMgr: (data: any) => {
        return api.post(`${BASE.api}/alert-save`, data);
    },
};

export const SF_ALTER_MGR_INFO: TFormSchema = {
    id: "form_alterMgrSrch",
    schema: {
        uid: {
            type: "text",
            label: "L_ALT_ID",
        },
        title: {
            type: "text",
            label: "L_ALT_NM",
        },
        condition: {
            type: "text",
            label: "L_CNDT",
        },
        updated: {
            type: "text",
            label: "L_UPDT_DT",
        },
        description: {
            type: "textarea",
            label: "L_ERR_DESC",
        },
    },
};

export const SF_ALTER_RVCR_INFO: TFormSchema = {
    id: "form_alterMgrSrch",
    schema: {
        alrtId: {
            type: "text",
            label: "L_ALT_ID",
            readOnly: true,
        },
        recptId: {
            type: "code",
            label: "L_RCVR_ID",
            area: "cstmOfcrCd",
            popupSize: "md",
        },
        recptDeptCd: {
            type: "code",
            label: "L_RCVR_DEPT_CD",
            area: "cstmOrgzCd",
            popupSize: "md",
        },
        actvtYn: {
            type: "select",
            label: "L_ACTVT_YN",
            all: true,
            area: "comnCd",
            comnCd: "COM0064",
        },
    },
};

export const SG_ALTER_MGR_LIST: TGridSchema = {
    id: "grid_alterMgrList",
    options: {
        pagination: "in",
        edit: false,
        index: true,
        height: 500,
    },

    head: [
        { cells: [{ header: "L_ALT_ID", binding: "uid", width: "*" }] },
        { cells: [{ header: "L_ALT_NM", binding: "title", width: "*" }] },
        { cells: [{ header: "L_CNDT", binding: "condition", width: "*" }] },
        { cells: [{ header: "L_UPDT_DT", binding: "updated", width: "*" }] },
        { cells: [{ header: "L_RCPN_YN", binding: "rcpnYn", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "uid" }] },
        { cells: [{ binding: "title" }] },
        { cells: [{ binding: "condition" }] },
        { cells: [{ binding: "updated" }] },
        { cells: [{ binding: "rcpnYn" }] },
    ],
};

export const SG_ALTER_RVCR_DEPT_LIST: TGridSchema = {
    id: "grid_alterRvcrList",
    options: {
        pagination: "in",
        edit: true,
        checkbox: true,
    },

    head: [
        { cells: [{ header: "L_ALT_ID", binding: "alrtId", width: "*" }], show: false },
        { cells: [{ header: "L_RCVR_DEPT_CD", binding: "recptDeptCd", width: "*" }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYn", width: "*" }] },
        { cells: [{ header: "L_NOTI_TP", binding: "notiTpCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "alrtId", readOnly: true }] },

        { cells: [{ binding: "recptDeptCd", type: "code", area: "cstmOrgzCd" }] },
        {
            cells: [
                {
                    binding: "actvtYn",
                    type: "select",
                    all: true,
                    area: "comnCd",
                    comnCd: "COM0064",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "notiTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "PTL0020",
                },
            ],
        },
    ],
};

export const SG_ALTER_RVCR_ID_LIST: TGridSchema = {
    id: "grid_alterRvcrList",
    options: {
        pagination: "in",
        edit: true,
        checkbox: true,
    },

    head: [
        { cells: [{ header: "L_ALT_ID", binding: "alrtId", width: "*" }], show: false },
        { cells: [{ header: "L_RCVR_ID", binding: "recptId", width: "*" }] },
        { cells: [{ header: "L_ACTVT_YN", binding: "actvtYn", width: "*" }] },
        { cells: [{ header: "L_NOTI_TP", binding: "notiTpCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "alrtId", readOnly: true }] },
        { cells: [{ binding: "recptId", type: "code", area: "cstmOfcrCd" }] },
        {
            cells: [
                {
                    binding: "actvtYn",
                    type: "select",
                    all: true,
                    area: "comnCd",
                    comnCd: "COM0064",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "notiTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "PTL0020",
                },
            ],
        },
    ],
};
